import { Components, checkboxClasses, Theme } from '@mui/material';

/**
 * Component overrides (i.e. global styles, default props) applied to
 * MuiCheckbox to make it match the design system.
 *
 * See: https://mui.com/material-ui/api/checkbox/#css
 */
export const MuiCheckbox: Components<Theme>['MuiCheckbox'] = {
  styleOverrides: {
    root: ({ theme }) => {
      const { checkbox } = theme.palette;
      if (checkbox) {
        return {
          // Slightly tighter than MUI default so hover/focus halo sits closer to the checkbox.
          // Making up the spacing difference using margin
          padding: theme.spacing(0.6),
          margin: theme.spacing(0.4),
          color: checkbox.uncheckedBorderColor,

          [`&:hover:not(.${checkboxClasses.disabled})`]: {
            backgroundColor: theme.palette.background.hover,
            borderRadius: theme.shape.controlRadius,
            [`&:not(.${checkboxClasses.checked}, .${checkboxClasses.indeterminate})`]: {
              color: checkbox.uncheckedHoverBorderColor,
            },
          },

          [`&.${checkboxClasses.checked}, &.${checkboxClasses.indeterminate}`]: {
            color: checkbox.checkedColor,
            [`&:hover:not(.${checkboxClasses.disabled})`]: {
              color: checkbox.checkedHoverColor,
            },
          },

          [`&.${checkboxClasses.disabled}`]: {
            color: checkbox.disabledColor,
          },
        };
      }

      return {
        color: theme.palette.border.bold,

        '&:hover': {
          backgroundColor: theme.palette.background.hover,
          borderRadius: '4px',

          [`&:not(.${checkboxClasses.checked}, .${checkboxClasses.indeterminate})`]: {
            color: theme.palette.text.legacySecondary,
          },
        },

        [`&.${checkboxClasses.disabled}`]: {
          color: theme.palette.border.default,
        },
      };
    },
  },
};
